import { Controller } from '@hotwired/stimulus';

import { browserTimeZone } from '../lib/timeZone';

export default class extends Controller {
  static targets = ['input'];

  connect() {
    if (!this.hasInputTarget) return;

    this.inputTarget.value = browserTimeZone() || '';
  }
}
